/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Tab_Profile_NewsInputs */

const en_us2_community_tab_profile_news = /** @type {(inputs: Community_Tab_Profile_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile, with news you have not seen yet`)
};

const pt_br2_community_tab_profile_news = /** @type {(inputs: Community_Tab_Profile_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil, com novidades que você ainda não viu`)
};

const es_419_community_tab_profile_news = /** @type {(inputs: Community_Tab_Profile_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil, con novedades que aún no has visto`)
};

const pt_pt2_community_tab_profile_news = /** @type {(inputs: Community_Tab_Profile_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil, com novidades que ainda não viste`)
};

const fr_fr2_community_tab_profile_news = /** @type {(inputs: Community_Tab_Profile_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil, avec des nouveautés que tu n'as pas encore vues`)
};

const de_de2_community_tab_profile_news = /** @type {(inputs: Community_Tab_Profile_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil, mit Neuigkeiten, die du noch nicht gesehen hast`)
};

const it_it2_community_tab_profile_news = /** @type {(inputs: Community_Tab_Profile_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo, con novità che non hai ancora visto`)
};

/**
* | output |
* | --- |
* | "Profile, with news you have not seen yet" |
*
* @param {Community_Tab_Profile_NewsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_tab_profile_news = /** @type {((inputs?: Community_Tab_Profile_NewsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Tab_Profile_NewsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_tab_profile_news(inputs)
	if (locale === "es-419") return es_419_community_tab_profile_news(inputs)
	if (locale === "pt-PT") return pt_pt2_community_tab_profile_news(inputs)
	if (locale === "fr-FR") return fr_fr2_community_tab_profile_news(inputs)
	if (locale === "de-DE") return de_de2_community_tab_profile_news(inputs)
	if (locale === "it-IT") return it_it2_community_tab_profile_news(inputs)
	return en_us2_community_tab_profile_news(inputs)
});
export { community_tab_profile_news as "community.tab_profile_news" }